import { useAtomValue } from 'jotai';
import { uiContextAtomDisplayMode } from '@rocco/states/uiContextAtomDisplayMode';
import type {
    ModuleDataColumn,
    PageBuilderModuleMetaProps,
} from '~/modules/page-builder/types';
import { ModuleColumnEnum } from 'generated/graphql';
import SingleParagraphModule from '../single-paragraph-module/SingleParagraphModule';
import SingleVideoModule from '../single-video-module/SingleVideoModule';

interface VideoParagraphModuleProps extends PageBuilderModuleMetaProps {
    columns: ModuleDataColumn[];
}

/**
 * A rendered Page Builder module for a video and paragraph.
 *
 * The editor version is at
 * {@link packages/web/app/modules/page-builder/component/edit/video-paragraph-module/VideoParagraphModule.tsx}
 */
const VideoParagraphModule = ({ columns, meta }: VideoParagraphModuleProps) => {
    const { isMobile } = useAtomValue(uiContextAtomDisplayMode);

    return (
        <div className="mx-auto grid w-full grid-cols-1 gap-x-6 gap-y-7 md:mx-12 md:max-w-full md:grid-cols-[65%_35%]">
            {columns.map((column) => {
                if (column.type === ModuleColumnEnum.VideoColumn) {
                    if (!column.video?.videoURL) {
                        return null;
                    }

                    return (
                        <SingleVideoModule
                            key={column.id}
                            column={column}
                            playIconSizeDesktop={98}
                            isSingleVideoParagraphModule={true}
                        />
                    );
                } else if (column.type === ModuleColumnEnum.TextColumn) {
                    if (!column.content && isMobile) {
                        return null;
                    }
                    return (
                        <SingleParagraphModule
                            key={column.id}
                            column={column}
                            meta={meta}
                            isNewDesign={true}
                        />
                    );
                }
                return null;
            })}
        </div>
    );
};

export default VideoParagraphModule;
